/**
 * Banner para atribuir conversa sem responsável ao usuário atual.
 */
import React from 'react';

interface ChatAssignBannerProps {
    onAssign: () => void;
}

export const ChatAssignBanner: React.FC<ChatAssignBannerProps> = ({ onAssign }) => (
    <aside
        className="flex items-center justify-center gap-s1 bg-chat-window-bg px-s4 py-s3"
        aria-label="Conversa não atribuída"
    >
        <p className="text-sm text-secondary">
            Conversa não atribuída.{' '}
            <button
                type="button"
                onClick={onAssign}
                className="inline-flex min-h-11 items-center text-sm font-medium text-primary underline underline-offset-4 transition-colors duration-150 ease-[cubic-bezier(.4,0,.2,1)] hover:text-primary-dark focus-visible:outline-hidden focus-visible:ring-2 focus-visible:ring-ring md:min-h-0"
            >
                Atribuir a mim
            </button>
        </p>
    </aside>
);
